import styles from './Section.module.scss';
import { type ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
  children: ReactNode;
  heading?: string;
  spacing?: 'default' | 'top' | 'bottom';
  contained?: boolean;
  addon?: ReactNode;
}

export function Section({ contained, ...props }: Props) {
  const { spacing = 'default' } = props;
  const sectionClassName = [
    styles['section'],
    contained && styles['section-contained'],
    styles['section-spacing-' + spacing],
  ]
    .filter(Boolean)
    .join(' ');

  const heading = props.heading != null && (
    <h2 className={clsx(styles['heading'])}>{props.heading}</h2>
  );

  return (
    <section className={sectionClassName}>
      <div className={styles['top']}>
        <div className={styles['heading']}>{heading}</div>
        {props.addon && <div className={styles['addon']}>{props.addon}</div>}
      </div>
      <div>{props.children}</div>
    </section>
  );
}
